import { CookieConfig, getCookieConfig } from "@amzn/aws-tc-experience-bridge-xps-registry";
import { useConfig } from "./useConfig";

export interface AdditionalCookieConfig {
  additionalCookies: CookieConfig;
}

export const useCookieRegistry = () => {
  const { additionalCookies } = useConfig();
  return getCookieConfig(additionalCookies);
};
